module.exports = __webpack_public_path__ + "rs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/rs.svg
// module id = 781
// module chunks = 0